<template>
  <div class="justify-content-around footer">
    <router-link class="footer-button" :to="'/app/home'">
      <div class="button-wrapper">
        <div class="button-content">
          <img class="menu-image" :src="getImgUrl('a.svg')" />
        </div>
      </div>
    </router-link>

    <router-link
      v-for="item in menuItems"
      :key="item.router"
      class="footer-button"
      :to="item.router"
    >
      <div class="button-wrapper">
        <div class="button-content">
          <i :class="item.icon"></i>
        </div>
      </div>
    </router-link>

    <router-link
      class="footer-button"
      v-if="!!getActiveCompany"
      :to="'/app/profile'"
    >
      <div class="button-wrapper">
        <div
          class="button-content company-icon"
          :style="'background-color:#a9e952'"
        >
          {{ getFirstChar(getActiveCompany.name) }}
        </div>
      </div>
    </router-link>
  </div>
</template>

<script>
import { menuItems } from "@/constants/menuItems";
import { mapGetters } from "vuex";

export default {
  name: "FooterMenu",
  data() {
    return {
      activeRouter: "/app/home",
      menuItems,
    };
  },
  methods: {
    getImgUrl(src) {
      let images = require.context("@/assets/img/", false);
      return images("./" + src);
    },

    getFirstChar(str) {
      if (!!str && str.length > 0) {
        return str.charAt(0);
      } else {
        return "";
      }
    },
  },
  computed: {
    ...mapGetters("app", ["getActiveCompany"]),
  },
};
</script>

<style scoped>
.footer {
  background-color: #fff;
  color: #b2ec5d;
  height: 100%;
  width: 50%;
  display: flex;
  border-radius: 32px;
  box-shadow: 0px 30px 30px 10px rgba(0,0,0,0.10);
  margin: 10px;
  margin-top: -100px;
  z-index: 999;
}

.footer-menu {
  width: 95% !important;
}

.footer .button-content {
  position: static;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.footer .button-wrapper {
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
  position: relative;
  z-index: 6;
  overflow: hidden;
}

.footer .footer-button {
  flex: 1 1 0;
  width: 0;
  border-radius: 0;
  font-size: 20px;
  font-weight: 400;
  line-height: 1em;
  text-transform: none;
  /*border: 1px solid gray;*/
}

.footer .footer-button:not([disabled]) {
  cursor: pointer;
}

a {
  color: #252734 !important;
}

a:hover {
  color: #b2ec5d;
  text-decoration: none;
}

a.active {
  color: #b2ec5d !important;
}

.menu-image {
  width: 1em;
  filter: grayscale(100%);
}

a.active .menu-image {
  color: #b2ec5d !important;
  filter: grayscale(0%);
}

a:hover .menu-image {
  filter: grayscale(0%);
}

.company-icon {
  color: #ffffff;
  padding: 3px;
  width: 28px;
  height: 28px;
  font-size: 14px;
  border-radius: 50%;
}
</style>
